@if (applyToMachinesOfSameTag) {
  <hr/>
}
@if (applyToMachinesOfSameTag) {
  <div
    class="alert alert-info mb-0"
    [innerHTML]="applyToMachinesOfSameTagMessage">
  </div>
}
